import { Box } from "@mui/material";
import Picker from 'rmc-picker'
import '../utils/picker.css'
import { useState } from "react";
import getSpeed from "./getSpeedText";
import { settingsInterface } from "../../../app/recipeCreation/createRecipe.types";

const BladeSpeedPicker = ({ index, speedValue, localSetting }: { index: number, speedValue: number, localSetting: Array<settingsInterface> }) => {
  const [value, setValue] = useState(speedValue)
  const onChange = (value: any) => {
    setValue(value)
    localSetting[index].speed = value
  }
  const valueArray = [0, 13, 14, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
  return (
    <Box style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
      <Picker indicatorClassName="my-picker-indicator"
        selectedValue={value}
        onValueChange={onChange}
      >
        {valueArray.map((value) => (
          <Picker.Item className='my-picker-view-item' value={value}>{getSpeed(value)}</Picker.Item>
        ))}
      </Picker>
    </Box>
  )
}

export default BladeSpeedPicker